export const sleep = async (ms: number): Promise<void> =>
  await new Promise((resolve) => setTimeout(resolve, ms))

export function debounce<Params extends any[]>(
  func: (...args: Params) => any,
  timeout: number
): (...args: Params) => NodeJS.Timeout {
  let timer: NodeJS.Timeout
  return (...args: Params) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, timeout)
    return timer
  }
}

export function formatEthHash(addr: string): string {
  if (addr.length <= 10) return addr
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`
}

const ethAddressReg = /^0x[a-fA-F0-9]{40}$/
export function isEthAddress(addr: string): boolean {
  return ethAddressReg.test(addr)
}

export function getErrorMessage(e: any): string | undefined {
  console.warn(e)
  let outMessage: string = ''
  let innerMessage: string = ''
  if (e.message && typeof e.message === 'string') {
    outMessage = e.message
  }
  if (
    e.error?.data?.originalError?.message &&
    typeof e.error?.data?.originalError?.message === 'string'
  ) {
    innerMessage = e.error.data.originalError.message
  }
  if (e.data?.message && typeof e.data?.message === 'string') {
    innerMessage = e.data.message
  }
  if (outMessage && !innerMessage) return outMessage
  if (!outMessage && innerMessage) return innerMessage
  if (!outMessage && !innerMessage) return
  return `${outMessage}: ${innerMessage}`
}

export function isMobile(windowWidth: number = window.innerWidth): boolean {
  return windowWidth <= 540
}
